<template>
  <div id="layout-sidenav" class="layout-sidenav-horizontal sidenav sidenav-horizontal flex-grow-0 container-p-x bg-white">
    <!-- Links -->
    <!--<a href="#" class="sidenav-horizontal-prev disabled"></a> -->
    <div class="sidenav-horizontal-wrapper">
      <ul class="sidenav-inner" style="margin-left: 0px;">
        <!-- Dashboards -->
        <li class="sidenav-item" :class="isCreditProgressActive">
          <b-link @click="navigateToTab('credit')" class="sidenav-link">
            <i class="sidenav-icon far fa-comments d-block"></i> <div>credit progress</div>
          </b-link>
        </li>
        <li class="sidenav-item" :class="isCourseProgressActive">
          <b-link class="sidenav-link" @click="navigateToTab('course')">
            <i class="sidenav-icon fas fa-users d-block"></i> <div>course progresss</div>
          </b-link>
        </li>
      </ul>
    </div>
    <!-- <a href="#" class="sidenav-horizontal-next disabled"></a> -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'secondaryNavbar',
  props: ['active'],
  components: {
  },
  data: () => {
    return {
    }
  },

  mounted () {
  },

  methods: {
    navigateToTab (tab) {
      if (tab === 'credit') {
        return this.$router.push({ name: 'streamDegree' })
      } else if (tab === 'course') {
        return this.$router.push({ name: 'streamDegreeCourse' })
      }
    }
  },

  computed: {
    ...mapState({
      'userObj': state => state.login.userObj
    }),
    isCreditProgressActive () {
      if (this.active === 'credit') {
        return 'active'
      } else {
        return ''
      }
    },
    isCourseProgressActive () {
      if (this.active === 'course') {
        return 'active'
      } else {
        return ''
      }
    }
  },

  watch: {
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/app/misc/components/StreamDegreeSecondaryNavbar.vue